module.exports = __webpack_public_path__ + "c3647d9bc890d2ebd383b80a3812e52f.svg";